import { render } from "./CouponList.vue?vue&type=template&id=bc5da27c&scoped=true"
import script from "./CouponList.vue?vue&type=script&lang=js"
export * from "./CouponList.vue?vue&type=script&lang=js"

import "./CouponList.vue?vue&type=style&index=0&id=bc5da27c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc5da27c"]])

export default __exports__